import Navbar from '../../navbar/Navbar';
import Footer from '../../footer/Footer';

import MCALeftTab from '../MCA/MCALeftTab'

const MCA = () => {
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 pe-lg-4 order-2 order-lg-1">

                            <MCALeftTab />
                        </div>
                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="how-to-apply">
                                <h2>
                                    Master of Computer Applications (MCA)
                                </h2>

                                <p>
                                    <strong>Department of Computer Applications</strong><br />
                                    The Department of Master of Computer Applications (MCA) has been established this year i.e., 2026, with an intake of 60. We have a good number of well qualified and dedicated faculty. Both students and faculty are motivated to constantly indulge in self-improvement and to keep themselves updated on par with the latest technology.
                                    We follow JNTUH R25 Syllabus and strive to go beyond the curriculum with a greater emphasis on practical knowledge.
                                </p>

                                {/* <div className="apply-list border-0">
                                    <h6>The department regularly hosts:</h6>
                                    <ul>
                                        <li>
                                            <i className="ri-checkbox-circle-line"></i>
                                            Intensive Coding Bootcamps & Hackathons
                                        </li>
                                        <li>
                                            <i className="ri-checkbox-circle-line"></i>
                                            Industry-led Workshops on Modern Frameworks
                                        </li>
                                        <li>
                                            <i className="ri-checkbox-circle-line"></i>
                                            Guest Lectures from Tech Architects and Consultants
                                        </li>
                                        <li>
                                            <i className="ri-checkbox-circle-line"></i>
                                            Technical Seminars on Global IT Trends
                                        </li>
                                    </ul>
                                </div>
                                 */}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default MCA;
